const tpl = (fields) => ({ page: 'triggers', ...fields })

export const TRIGGER_TEMPLATES_PART03 = [
  tpl({
    id: 'demo-tpl-trg-meeting-booked',
    title: 'Prep when a meeting is booked',
    category: 'Ops',
    when: { app: 'Google Calendar', event: 'Event created' },
    apps: ['Google Calendar', 'HubSpot', 'Gmail'],
    description: 'A new external meeting gets a context note the moment it lands on your calendar.',
    steps: [
      'Check whether the attendees are customers, prospects, or new',
      'Gather the last thread and the deal status',
      'Email you a short context note',
    ],
    prompt:
      'When a meeting with external attendees is added to my Google Calendar, look them up in HubSpot and Gmail and email me a short context note: who they are, the deal status, and our last conversation.',
  }),
  tpl({
    id: 'demo-tpl-trg-notion-task',
    title: 'Notion task to focus time',
    category: 'Ops',
    when: { app: 'Notion', event: 'Page created' },
    apps: ['Notion', 'Google Calendar'],
    description: 'Tasks assigned to you get time on your calendar, not just a due date.',
    steps: ['Watch the Tasks database for tasks assigned to you', 'Read the due date and estimate', 'Block focus time the working day before'],
    prompt:
      'When a task is assigned to me in the Notion Tasks database with a due date, block 45 minutes of focus time on my Google Calendar the working day before it is due.',
  }),
]
